<script setup>

import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据

import { useI18n } from 'vue-i18n'

const { t } = useI18n()

import HzQuickjump from '@/components/main/HzQuickjump.vue'


const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)

// 快捷跳转
const quickJump = ref([
    { id: 4, name: t('service.quickJump.basicService'), target: 'Heziyun-serviceSupport' },
    { id: 1, name: t('service.quickJump.filing'), target: 'Heziyun-zeroYuanFiling' },
    { id: 2, name: t('service.quickJump.compensation'), target: 'Heziyun-FaultCompensation' },
    { id: 3, name: t('service.quickJump.refund'), target: 'Heziyun-Refund' },
])
// 工单跳转
const jumpTo = () => {
    const frontMenusStr = localStorage.getItem('frontMenus')

    if (frontMenusStr) {
        try {
            const frontMenus = JSON.parse(frontMenusStr)
            const ticketMenu = frontMenus.find(menu => menu.url && menu.url.includes('ticket.htm'))

            if (ticketMenu) {
                window.open(ticketMenu.url, '_blank')
            } else {
                window.open('/home.htm', '_blank')
            }
        } catch (error) {
            console.error('解析 frontMenus 数据失败:', error)
        }
    } else {
        window.open('/home.htm', '_blank')
    }
}

// qq数据处理
const qqList = computed(() => {
  const qq = HeziyunData.value?.qq || ''

  if (Array.isArray(qq)) {
    return qq
  }

  return qq
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
})

</script>

<template>

    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('service.bannerTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 200 }">
                    {{ $t('service.bannerDesc') }}
                </p>
            </div>
        </div>
    </div>

    <HzQuickjump :quickjump="quickJump"></HzQuickjump>

    <!-- 7X24小时全天候服务支持 -->
    <div class="Heziyun-serviceSupport Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('service.basicServiceTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{
                    $t('service.basicServiceSubtitle') }}</p>
            </div>
            <div class="Heziyun-support">
                <div class="Heziyun-grid" v-intersect="{ class: 'left-right', delay: 0 }">
                    <div class="Heziyun-heades">
                        <span>{{ $t('service.support24x7Title') }}</span>
                        <p>{{ $t('service.support24x7Desc') }}</p>
                    </div>
                    <div class="Heziyun-contents">
                        <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span>{{ $t('service.preSales') }}</span>
                                <p>{{ $t('service.preSalesDesc') }}</p>
                            </div>
                            <a href="#" @click="jumpTo()" class="Heziyun-buttonLink">{{
                                $t('service.preSalesConsult') }} ></a>
                        </div>
                        <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span>{{ $t('service.duringSales') }}</span>
                                <p>{{ $t('service.duringSalesDesc') }}</p>
                            </div>
                            <a href="#" @click="jumpTo()" class="Heziyun-buttonLink">{{
                                $t('service.duringSalesConsult') }} ></a>
                        </div>
                        <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span>{{ $t('service.afterSales') }}</span>
                                <p>{{ $t('service.afterSalesDesc') }}</p>
                            </div>
                            <a href="#" @click="jumpTo()" class="Heziyun-buttonLink">{{
                                $t('service.afterSalesConsult') }} ></a>
                        </div>
                        <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span>{{ $t('service.technicalTicket') }}</span>
                                <p>{{ $t('service.technicalTicketDesc') }}</p>
                            </div>
                            <a href="#" @click="jumpTo()" class="Heziyun-buttonLink">{{
                                $t('service.submitTicket') }} ></a>
                        </div>
                    </div>
                </div>

                <div class="Heziyun-grid" v-intersect="{ class: 'right-left', delay: 0 }">
                    <div class="Heziyun-heades">
                        <span>{{ $t('service.vipServiceTitle') }}</span>
                        <p>{{ $t('service.vipServiceDesc') }}</p>
                    </div>
                    <div class="Heziyun-contents">
                        <!-- <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span><img src="@/static/img/guarantee/itemGroup1.svg" alt="">{{
                                    $t('service.wechatGroup') }}</span>
                                <p>{{ $t('service.wechatGroupDesc') }}</p>
                            </div>
                        </div> -->
                        <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span><img src="@/static/img/guarantee/itemGroup2.svg" alt="">{{
                                    $t('service.qqContact') }}</span>
                                <p>{{ $t('service.qqContactDesc') }}</p>
                            </div>
                            <div class="Heziyun-box">
                                <div class="Heziyun-items" v-for="(item, index) in qqList" :key="item">
                                    <a :href="`http://wpa.qq.com/msgrd?v=3&uin=${item}&site=qq&menu=yes`"
                                        target="_blank" class="Heziyun-buttonLink" v-if="index <= 1">
                                        QQ({{ index + 1 }})：{{ item }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="Heziyun-item">
                            <div class="Heziyun-title">
                                <span><img src="@/static/img/guarantee/itemGroup3.svg" alt="">{{
                                    $t('service.consultationHotline') }}</span>
                                <p>{{ $t('service.consultationHotlineDesc') }}</p>
                            </div>
                            <a :href="`tel:${HeziyunData?.phone}`" class="Heziyun-buttonLink">{{
                                HeziyunData?.phone }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 0 元免费备案 -->
    <div class="Heziyun-zeroYuanFiling Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('service.filingTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('service.filingSubtitle') }}
                </p>
            </div>
            <div class="Heziyun-keepOnRecord">
                <div class="Heziyun-steps">
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 200 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot1.png" alt="">
                        </div>
                        <span>{{ $t('service.filingStep1') }}</span>
                    </div>
                    <div class="Heziyun-horizontalLine" v-intersect="{ class: 'right-left', delay: 200 }">
                        <svg t="1766372815754" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4019" width="128" height="128">
                            <path
                                d="M406.4 144l422.4 297.6c44.8 32 44.8 112 0 144l-422.4 297.6c-44.8 32-118.4 9.6-118.4-54.4V195.2c3.2-64 76.8-83.2 118.4-51.2z"
                                fill="#91c0f8" p-id="4020"></path>
                        </svg>
                    </div>
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 300 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot2.png" alt="">
                        </div>
                        <span>{{ $t('service.filingStep2') }}</span>
                    </div>
                    <div class="Heziyun-horizontalLine" v-intersect="{ class: 'right-left', delay: 300 }">
                        <svg t="1766372815754" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4019" width="128" height="128">
                            <path
                                d="M406.4 144l422.4 297.6c44.8 32 44.8 112 0 144l-422.4 297.6c-44.8 32-118.4 9.6-118.4-54.4V195.2c3.2-64 76.8-83.2 118.4-51.2z"
                                fill="#91c0f8" p-id="4020"></path>
                        </svg>
                    </div>
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 400 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot3.png" alt="">
                        </div>
                        <span>{{ $t('service.filingStep3') }}</span>
                    </div>
                    <div class="Heziyun-horizontalLine" v-intersect="{ class: 'right-left', delay: 400 }">
                        <svg t="1766372815754" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4019" width="128" height="128">
                            <path
                                d="M406.4 144l422.4 297.6c44.8 32 44.8 112 0 144l-422.4 297.6c-44.8 32-118.4 9.6-118.4-54.4V195.2c3.2-64 76.8-83.2 118.4-51.2z"
                                fill="#91c0f8" p-id="4020"></path>
                        </svg>
                    </div>
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 500 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot4.png" alt="">
                        </div>
                        <span>{{ $t('service.filingStep4') }}</span>
                    </div>
                </div>
                <a href="/home.htm" v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                    $t('service.filingButton') }}</a>
                <div class="Heziyun-problemText">
                    <div class="Heziyun-titles" v-intersect="{ class: 'bottom-top', delay: 0 }">
                        <img src="@/static/img/guarantee/common.svg" alt="">
                        {{ $t('service.faqTitle') }}
                    </div>
                    <div class="Heziyun-assemble">
                        <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 100 }">
                            <span>{{ $t('service.faq1Question') }}</span>
                            <p>{{ $t('service.faq1Answer') }}</p>
                        </div>
                        <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 200 }">
                            <span>{{ $t('service.faq2Question') }}</span>
                            <p>{{ $t('service.faq2Answer') }}</p>
                        </div>
                        <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 300 }">
                            <span>{{ $t('service.faq3Question') }}</span>
                            <p>{{ $t('service.faq3Answer') }}</p>
                        </div>
                        <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 400 }">
                            <span>{{ $t('service.faq4Question') }}</span>
                            <p>{{ $t('service.faq4Answer') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 100倍故障赔偿 -->
    <div class="Heziyun-FaultCompensation Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('service.compensationTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">
                    {{ $t('service.compensationSubtitle') }}
                </p>
            </div>
            <div class="Heziyun-compensateFor">
                <div class="Heziyun-steps" v-intersect="{ class: 'right-left', delay: 0 }">
                    <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 100 }">
                        <img src="@/static/img/guarantee/itemAbility1.png" alt="">
                        <span>{{ $t('service.compensationStep1') }}</span>
                    </div>
                    <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 200 }">
                        <img src="@/static/img/guarantee/itemAbility2.png" alt="">
                        <span>{{ $t('service.compensationStep2') }}</span>
                    </div>
                    <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 300 }">
                        <img src="@/static/img/guarantee/itemAbility3.png" alt="">
                        <span>{{ $t('service.compensationStep3') }}</span>
                    </div>
                    <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 400 }">
                        <img src="@/static/img/guarantee/itemAbility4.png" alt="">
                        <span>{{ $t('service.compensationStep4') }}</span>
                    </div>
                    <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 500 }">
                        <img src="@/static/img/guarantee/itemAbility5.png" alt="">
                        <span>{{ $t('service.compensationStep5') }}</span>
                    </div>
                </div>
                <div class="Heziyun-compensationType">
                    <div class="Heziyun-title" v-intersect="{ class: 'right-left', delay: 0 }">{{
                        $t('service.compensationTypes') }}</div>
                    <div class="Heziyun-threeTypes">
                        <div class="Heziyun-itemType" v-intersect="{ class: 'right-left', delay: 100 }">
                            <img src="@/static/img/guarantee/itemType1.webp" alt="">
                            <span>{{ $t('service.compensationType1') }}</span>
                            <p>{{ $t('service.compensationType1Desc') }}</p>
                        </div>
                        <div class="Heziyun-itemType" v-intersect="{ class: 'right-left', delay: 200 }">
                            <img src="@/static/img/guarantee/itemType2.webp" alt="">
                            <span>{{ $t('service.compensationType2') }}</span>
                            <p>{{ $t('service.compensationType2Desc') }}</p>
                        </div>
                        <div class="Heziyun-itemType" v-intersect="{ class: 'right-left', delay: 300 }">
                            <img src="@/static/img/guarantee/itemType3.webp" alt="">
                            <span>{{ $t('service.compensationType3') }}</span>
                            <p>{{ $t('service.compensationType3Desc') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 1天无理由退款 -->
    <div class="Heziyun-Refund Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('service.refundTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">
                    {{ $t('service.refundSubtitle') }}
                </p>
            </div>
            <div class="Heziyun-refund">
                <div class="Heziyun-steps">
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 200 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot5.png" alt="">
                        </div>
                        <span>{{ $t('service.refundStep1') }}</span>
                        <p>{{ $t('service.refundStep1Desc') }}</p>
                    </div>
                    <div class="Heziyun-horizontalLine" v-intersect="{ class: 'right-left', delay: 200 }">
                        <svg t="1766372815754" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4019" width="128" height="128">
                            <path
                                d="M406.4 144l422.4 297.6c44.8 32 44.8 112 0 144l-422.4 297.6c-44.8 32-118.4 9.6-118.4-54.4V195.2c3.2-64 76.8-83.2 118.4-51.2z"
                                fill="#91c0f8" p-id="4020"></path>
                        </svg>
                    </div>
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 300 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot6.png" alt="">
                        </div>
                        <span>{{ $t('service.refundStep2') }}</span>
                        <p>{{ $t('service.refundStep2Desc') }}</p>
                    </div>
                    <div class="Heziyun-horizontalLine" v-intersect="{ class: 'right-left', delay: 300 }">
                        <svg t="1766372815754" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4019" width="128" height="128">
                            <path
                                d="M406.4 144l422.4 297.6c44.8 32 44.8 112 0 144l-422.4 297.6c-44.8 32-118.4 9.6-118.4-54.4V195.2c3.2-64 76.8-83.2 118.4-51.2z"
                                fill="#91c0f8" p-id="4020"></path>
                        </svg>
                    </div>
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 400 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot7.png" alt="">
                        </div>
                        <span>{{ $t('service.refundStep3') }}</span>
                        <p>{{ $t('service.refundStep3Desc') }}</p>
                    </div>
                    <div class="Heziyun-horizontalLine" v-intersect="{ class: 'right-left', delay: 400 }">
                        <svg t="1766372815754" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4019" width="128" height="128">
                            <path
                                d="M406.4 144l422.4 297.6c44.8 32 44.8 112 0 144l-422.4 297.6c-44.8 32-118.4 9.6-118.4-54.4V195.2c3.2-64 76.8-83.2 118.4-51.2z"
                                fill="#91c0f8" p-id="4020"></path>
                        </svg>
                    </div>
                    <div class="Heziyun-itemTrot" v-intersect="{ class: 'right-left', delay: 500 }">
                        <div class="Heziyun-box"><img src="@/static/img/guarantee/itemTrot8.png" alt="">
                        </div>
                        <span>{{ $t('service.refundStep4') }}</span>
                        <p>{{ $t('service.refundStep4Desc') }}</p>
                    </div>
                </div>

                <div class="Heziyun-refundIssue" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-titles">
                        <img src="@/static/img/guarantee/common.svg" alt="">
                        {{ $t('service.refundFaqTitle') }}
                    </div>
                    <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 100 }">
                        <span>{{ $t('service.refundFaq1Question') }}</span>
                        <p>{{ $t('service.refundFaq1Answer') }}</p>
                    </div>
                    <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 200 }">
                        <span>{{ $t('service.refundFaq2Question') }}</span>
                        <p>{{ $t('service.refundFaq2Answer') }}</p>
                    </div>
                    <div class="Heziyun-itemSketch" v-intersect="{ class: 'bottom-top', delay: 300 }">
                        <span>{{ $t('service.refundFaq3Question') }}</span>
                        <p>{{ $t('service.refundFaq3Answer') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
@import "@/static/css/import";
@import "@/static/font/font.css";
</style>

<style lang="less" scoped>
// banner图
.Heziyun-banners {
    background: url('@/static/img/guarantee/banner2.png') no-repeat center;
    background-size: cover;
    position: relative;
    height: 25rem;
    padding: 0;
    margin-top: 3.6rem;


    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;
        height: 100%;

        .Heziyun-banner-title {
            span {
                color: #f9fafc;
            }

            p {
                text-align: left;
                color: #f9fafc;
            }
        }
    }

}

// 0 元免费备案
.Heziyun-zeroYuanFiling {
    background-color: #fafafa;

    .Heziyun-defaultWidth {

        .Heziyun-keepOnRecord {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            align-items: center;

            .Heziyun-steps {
                width: 100%;
                display: grid;
                grid-template-columns: 0.8fr 1fr 0.8fr 1fr 0.8fr 1fr 0.8fr;
                align-items: center;

                .Heziyun-itemTrot {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 1rem;

                    .Heziyun-box {
                        background-image: linear-gradient(0deg, #ffffff 0%, #f3f5f8 100%);
                        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, 0.1);
                        border: 2px solid #fff;
                        border-radius: 50%;
                        padding: 0.5rem;

                        img {
                            width: 2.5rem;
                            height: 2.5rem;
                            object-fit: contain;
                        }
                    }

                    span {
                        color: #25345c;
                        font-size: 1rem;
                    }

                    p {
                        color: #676c83;
                        line-height: 1.6;
                        text-align: center;
                    }
                }

                .Heziyun-horizontalLine {
                    background: rgb(217, 226, 244);
                    height: 0.1rem;
                    position: relative;

                    svg {
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 1;
                    }
                }
            }

            a {
                background-color: #0066FF;
                padding: 0.8rem 2rem;
                color: #fff;
                border-radius: 0.3rem;
                margin-top: 4rem;

                &:hover {
                    background-color: #578cff;
                }
            }

            .Heziyun-problemText {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                margin: 4rem 2rem 0 2rem;
                background-color: #fff;
                padding: 1.5rem;
                border-radius: 0.5rem;
                width: 100%;

                .Heziyun-titles {
                    color: rgb(9, 14, 29);
                    font-size: 1.2rem;
                    display: flex;
                    align-items: center;
                    gap: 0.3rem;
                    font-weight: bold;

                    img {
                        object-fit: contain;
                        width: 1rem;
                        height: 1rem;
                    }
                }

                .Heziyun-assemble {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;

                    .Heziyun-itemSketch {
                        padding: 1.5rem;
                        border-radius: 0.5rem;
                        background: #fafafa;

                        span {
                            color: #25345c;
                            font-size: 1rem;
                            font-weight: bold;
                        }

                        p {
                            margin-top: 0.5rem;
                            color: #828282;
                            line-height: 1.7;
                        }
                    }
                }
            }
        }
    }
}

// 100倍故障赔偿
.Heziyun-FaultCompensation {
    background-color: #fff;

    .Heziyun-defaultWidth {

        .Heziyun-compensateFor {
            .Heziyun-steps {
                display: flex;
                justify-content: space-between;
                position: relative;
                padding: 2rem 0;

                .Heziyun-itemAbility {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 1rem;

                    img {
                        width: 3rem;
                        height: 3rem;
                        object-fit: contain;
                    }

                    span {
                        color: #25345c;
                        font-size: 0.85rem;
                    }
                }
            }

            .Heziyun-compensationType {
                margin-top: 4rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 3rem;

                .Heziyun-title {
                    color: #252d4d;
                    font-size: 1.5rem;
                }

                .Heziyun-threeTypes {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 2rem;

                    .Heziyun-itemType {
                        padding: 1.5rem;
                        display: flex;
                        flex-direction: column;
                        gap: 1rem;
                        border: 2px solid #fff;
                        border-radius: 4px;
                        background: linear-gradient(180deg, #f4f5f8 4%, rgba(255, 255, 255, 0.7) 100%);
                        box-shadow: 0px 3px 6px 0px rgba(37, 56, 108, .05), 0px 12px 20px 0px rgba(49, 70, 125, .08);

                        &:nth-of-type(1) {
                            background: linear-gradient(180deg, #e0ebff 0%, #fefeff 100%);
                        }

                        &:nth-of-type(2) {
                            background: linear-gradient(180deg, #DAEEFD 0%, #FEFEFF 100%, #FEFEFE 100%);
                        }

                        &:nth-of-type(3) {
                            background: linear-gradient(180deg, #e3e9ff 0%, #FFFFFF 100%);
                        }

                        img {
                            width: 2.5rem;
                            height: 2.5rem;
                            object-fit: contain;
                        }

                        span {
                            color: #252d4d;
                            font-size: 1.1rem;
                        }

                        p {
                            color: #676c83;
                            font-size: 0.85rem;
                            line-height: 1.7;
                        }
                    }
                }
            }
        }
    }
}

// 1天无理由退款
.Heziyun-Refund {
    background-color: rgb(250, 250, 250);

    .Heziyun-defaultWidth {

        .Heziyun-refund {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 2rem;

            .Heziyun-steps {
                width: 100%;
                display: grid;
                grid-template-columns: 0.8fr 1fr 0.8fr 1fr 0.8fr 1fr 0.8fr;
                align-items: center;

                .Heziyun-itemTrot {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 1rem;

                    .Heziyun-box {
                        background-image: linear-gradient(0deg, #ffffff 0%, #f3f5f8 100%);
                        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, 0.1);
                        border: 2px solid #fff;
                        border-radius: 50%;
                        padding: 0.7rem;

                        img {
                            width: 2.3rem;
                            height: 2.3rem;
                            object-fit: contain;
                        }
                    }

                    span {
                        color: #25345c;
                        font-size: 1rem;
                    }

                    p {
                        color: #676c83;
                        line-height: 1.6;
                        text-align: center;
                    }
                }

                .Heziyun-horizontalLine {
                    background: rgb(217, 226, 244);
                    height: 0.1rem;
                    position: relative;

                    svg {
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 1;
                    }
                }
            }

            .Heziyun-refundIssue {
                padding: 1.2rem;
                border-radius: 1rem;
                -webkit-border-radius: 1rem;
                -moz-border-radius: 1rem;
                -ms-border-radius: 1rem;
                -o-border-radius: 1rem;
                background: #fff;
                border: 0.06rem solid rgba(255, 255, 255, 0.2);
                backdrop-filter: blur(0.63rem);
                display: flex;
                flex-direction: column;
                gap: 1rem;
                overflow: hidden;
                margin: 4rem 2rem 0 2rem;

                .Heziyun-titles {
                    display: flex;
                    align-items: center;
                    gap: 0.3rem;
                    color: #25345c;
                    font-size: 1.2rem;

                    img {
                        object-fit: contain;
                        width: 1rem;
                        height: 1rem;
                    }
                }

                .Heziyun-itemSketch {
                    padding: 1.2rem;
                    border-radius: 1rem;
                    -webkit-border-radius: 1rem;
                    -moz-border-radius: 1rem;
                    -ms-border-radius: 1rem;
                    -o-border-radius: 1rem;
                    background: #fafafa;

                    span {
                        color: #25345c;
                        font-size: 1rem;
                        font-weight: bold;
                    }

                    p {
                        margin-top: 0.5rem;
                        color: #676c83;
                        line-height: 1.3rem;
                        font-size: 0.8rem;
                    }
                }
            }
        }
    }
}

// 7X24小时全天候服务支持
.Heziyun-serviceSupport {
    background-color: #f9fafc;

    .Heziyun-defaultWidth {

        .Heziyun-support {
            display: flex;
            justify-content: center;
            gap: 1rem;

            .Heziyun-grid {
                width: 45%;

                .Heziyun-heades {
                    padding: 1.5rem;
                    background: url('@/static/img/guarantee/8f805c73.jpg') no-repeat center;
                    background-size: cover;

                    span {
                        color: #191c3d;
                        font-size: 1rem;
                    }

                    p {
                        color: #191c3d;
                        margin-top: 1rem;
                    }
                }

                .Heziyun-contents {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 2px;

                    .Heziyun-item {
                        background-color: #fff;
                        padding: 1rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 180px;

                        &:hover {
                            box-shadow: 0 10px 20px 0 rgba(0, 0, 0, .05);
                        }

                        .Heziyun-title {
                            span {
                                color: #191c3d;
                                font-size: 0.9rem;
                                display: flex;
                                align-items: center;
                                gap: 0.3rem;

                                img {
                                    width: 1rem;
                                    height: 1rem;
                                    filter: brightness(0.5);
                                    object-fit: contain;
                                }
                            }

                            p {
                                color: rgba(25, 28, 61, .5);
                                margin-top: 0.5rem;
                                line-height: 1.6;
                                    font-size: 0.7rem;
                            }
                        }

                        .Heziyun-buttonLink {
                            font-size: 13px;
                            color: #2164ed;
                            width: max-content;

                            &:hover {
                                color: #81b1fa;
                            }
                        }

                        .Heziyun-box {
                            // 一行两个
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            gap: 0.5rem;
                            color: rgba(25, 28, 61, .5);
                        }
                    }
                }
            }

            .Heziyun-grid:last-child {

                .Heziyun-heades {
                    background: url('@/static/img/guarantee/djdajshdg.webp') no-repeat center;
                    background-size: cover;
                }
            }
        }


    }
}


@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        background: url('@/static/img/guarantee/banner.png') no-repeat right;
        background-size: cover;
        height: 80vw;
        margin-top: 15vw;

        .Heziyun-defaultWidth {
            .Heziyun-banner-title {
                align-items: center;

                span {
                    color: #0A192F;
                }

                p {
                    color: #0A192F;
                    text-align: center;
                }
            }
        }
    }

    // 0 元免费备案
    .Heziyun-zeroYuanFiling {

        .Heziyun-defaultWidth {

            .Heziyun-keepOnRecord {
                gap: 4vw;

                .Heziyun-steps {
                    grid-template-columns: repeat(1, 1fr);
                    gap: 3vw;
                    justify-items: center;

                    .Heziyun-itemTrot {
                        gap: 4vw;

                        .Heziyun-box {
                            padding: 3vw;

                            img {
                                width: 10vw;
                                height: 10vw;
                            }
                        }

                        span {
                            font-size: 4.5vw;
                        }
                    }

                    .Heziyun-horizontalLine {
                        height: 20vw;
                        width: 1px;

                        svg {
                            width: 5vw;
                            height: 5vw;
                            transform: translate(-50%, -50%) rotate(90deg);
                        }
                    }
                }

                a {
                    padding: 2vw 5vw;
                    color: #fff;
                    border-radius: 1vw;
                    margin-top: 4vw;
                    font-size: 4vw;
                }

                .Heziyun-problemText {
                    gap: 3vw;
                    width: 100%;
                    margin: 0;
                    padding: 5vw;

                    .Heziyun-titles {
                        font-size: 4.5vw;
                        gap: 2vw;

                        img {
                            width: 4vw;
                            height: 4vw;
                        }
                    }

                    .Heziyun-assemble {
                        gap: 3vw;

                        .Heziyun-itemSketch {
                            padding: 4vw;
                            border-radius: 1cqh;
                            -webkit-border-radius: 1cqh;
                            -moz-border-radius: 1cqh;
                            -ms-border-radius: 1cqh;
                            -o-border-radius: 1cqh;

                            span {
                                font-size: 4vw;
                            }

                            p {
                                margin-top: 3vw;
                                line-height: 6vw;
                                font-size: 3.5vw;
                            }
                        }
                    }
                }
            }
        }
    }

    // 100倍故障赔偿
    .Heziyun-FaultCompensation {

        .Heziyun-defaultWidth {
            .Heziyun-commodity-title {
                span {
                    font-size: 6vw;
                }

                p {}
            }

            .Heziyun-compensateFor {
                .Heziyun-steps {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10vw 3vw;
                    padding: 2vw 0 6vw 0;

                    &::after {
                        content: "";
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        height: 0.5vw;
                    }

                    .Heziyun-itemAbility {
                        gap: 4vw;

                        img {
                            width: 10vw;
                            height: 10vw;
                        }

                        span {
                            font-size: 4vw;
                        }
                    }
                }

                .Heziyun-compensationType {
                    margin-top: 5vw;
                    gap: 4vw;

                    .Heziyun-title {
                        font-size: 5vw;
                    }

                    .Heziyun-threeTypes {
                        grid-template-columns: repeat(1, 1fr);
                        gap: 5vw;

                        .Heziyun-itemType {
                            padding: 7vw;
                            border-radius: 2vw;
                            -webkit-border-radius: 2vw;
                            -moz-border-radius: 2vw;
                            -ms-border-radius: 2vw;
                            -o-border-radius: 2vw;
                            gap: 3vw;

                            img {
                                width: 8vw;
                                height: 8vw;
                            }

                            span {
                                font-size: 4.5vw;
                            }

                            p {
                                font-size: 3.5vw;
                                line-height: 6vw;
                            }
                        }
                    }
                }
            }
        }
    }

    // 1天无理由退款
    .Heziyun-Refund {

        .Heziyun-defaultWidth {

            .Heziyun-refund {
                grid-template-columns: repeat(1, 1fr);
                gap: 4vw;

                .Heziyun-steps {
                    grid-template-columns: repeat(1, 1fr);
                    gap: 3vw;
                    justify-items: center;

                    .Heziyun-itemTrot {
                        gap: 4vw;

                        .Heziyun-box {
                            padding: 3vw;

                            img {
                                width: 10vw;
                                height: 10vw;
                            }
                        }

                        span {
                            font-size: 4.5vw;
                        }
                    }

                    .Heziyun-horizontalLine {
                        height: 20vw;
                        width: 1px;

                        svg {
                            width: 5vw;
                            height: 5vw;
                            transform: translate(-50%, -50%) rotate(90deg);
                        }
                    }
                }

                .Heziyun-refundIssue {
                    padding: 4vw;
                    border-radius: 2vw;
                    -webkit-border-radius: 2vw;
                    -moz-border-radius: 2vw;
                    -ms-border-radius: 2vw;
                    -o-border-radius: 2vw;
                    gap: 3vw;

                    .Heziyun-titles {
                        gap: 2vw;
                        font-size: 5vw;

                        img {
                            width: 5vw;
                            height: 5vw;
                        }
                    }

                    .Heziyun-itemSketch {
                        padding: 3vw;
                        border-radius: 2vw;
                        -webkit-border-radius: 2vw;
                        -moz-border-radius: 2vw;
                        -ms-border-radius: 2vw;
                        -o-border-radius: 2vw;

                        span {
                            font-size: 4vw;
                        }

                        p {
                            margin-top: 3vw;
                            line-height: 1.7;
                            font-size: 3.5vw;
                        }
                    }
                }
            }
        }
    }

    // 7X24小时全天候服务支持
    .Heziyun-serviceSupport {
        background-color: #f9fafc;

        .Heziyun-defaultWidth {

            .Heziyun-support {
                flex-direction: column;
                gap: 5vw;

                .Heziyun-grid {
                    width: 100%;

                    .Heziyun-heades {
                        padding: 4vw;

                        span {
                            font-size: 4.5vw;
                        }

                        p {
                            font-size: 3.5vw;
                            margin-top: 3vw;
                            line-height: 1.7;
                        }
                    }

                    .Heziyun-contents {
                        display: grid;
                        grid-template-columns: repeat(1, 1fr);
                        gap: 2px;

                        .Heziyun-item {
                            padding: 4vw;
                            max-height: 45vw;
                            height: auto;
                            gap: 5vw;

                            .Heziyun-title {
                                span {
                                    font-size: 4.5vw;
                                    gap: 2vw;

                                    img {
                                        width: 5vw;
                                        height: 5vw;
                                    }
                                }

                                p {
                                    color: rgba(25, 28, 61, .5);
                                    margin-top: 4vw;
                                    line-height: 1.6;
                                    font-size: 3.5vw;
                                }
                            }

                            .Heziyun-buttonLink {
                                font-size: 3.5vw;
                            }

                            .Heziyun-box {
                                gap: 2vw;
                            }
                        }
                    }
                }
            }


        }
    }
}
</style>